package org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.devices

import org.hs_soft.runmynesto.domain.util.helper.LanguageManager

enum class CafeModeEnum(val value: Int) {
    REDUCED_VAT(value = 0),
    VAT_RATE_SELECTION(value = 1),
    NORMAL_VAT(value = 2);

    val title: String
        get() = LanguageManager.getCurrentStrings().let { strings ->
            when (this) {
                REDUCED_VAT -> strings.reducedVat
                VAT_RATE_SELECTION -> strings.vatRateSelection
                NORMAL_VAT -> strings.normalVat
            }
        }
}